export default "__VITE_ASSET__CUD$8QnA__"